import React from 'react';
import MaskedInput from 'react-text-mask';
var defaultProps = {
  name: 'phoneNumber',
  id: null,
  onChange: function onChange() {
    return null;
  },
  placeholder: '(123) 456-7890',
  value: '',
  required: false,
  // mask documentation: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#mask
  mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};
export default function PhoneInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    name = _ref.name,
    placeholder = _ref.placeholder,
    _onChange = _ref.onChange,
    required = _ref.required,
    mask = _ref.mask;
  return /*#__PURE__*/React.createElement(MaskedInput, {
    mask: mask,
    id: id,
    guide: true,
    placeholder: placeholder,
    name: name,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e, e.target);
    },
    required: required
  });
}
PhoneInput.defaultProps = defaultProps;